import "./SubmersiblePumps.module.css";
import Header from "@/reusable_sections/Header";
import Plumbinghero from "./sections/Plumbinghero";
import Boosterpumpsolutions from "./sections/Boosterpumpsolutions";
import ServiceAreaMap from "./sections/ServiceAreaMap";
import PlumbingCall from "./sections/PlumbingCall";
import Footer from "@/reusable_sections/Footer";
export default function SubmersiblePumpsPage() {
  return <div>
      <Header />
      <Plumbinghero />
      <Boosterpumpsolutions />
      <ServiceAreaMap />
      <PlumbingCall />
      <Footer />
    </div>;
}